// extracted by mini-css-extract-plugin
export default {"victory":"MatchNone_victory__iHnD6","fadein":"MatchNone_fadein__xhiHq","meta":"MatchNone_meta__0rvzN"};